import React, { useEffect, useState } from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { ButtonGoToTopProps } from "./buttonGoToTop.types";

import { scrollTop } from "@/utils/helpers";
import { useScrollValue } from "@/hooks/useScrollValue";

import s from "./buttonGoToTop.module.scss";

const ButtonGoToTop = ({ size, variant, iconRounded }: ButtonGoToTopProps) => {
  const valueScroll = useScrollValue();
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    setShowScroll(valueScroll > 0);
  }, [valueScroll]);

  function handleGoTop() {
    scrollTop();
  }

  return (
    <div className={s.button_go_top} data-isvisible={showScroll}>
      <button
        className={`${s.button} btn btn-icon btn-${size} btn-${variant} ${iconRounded ? "btn-icon-rounded" : ""}`}
        onClick={handleGoTop}
        data-isvisible={showScroll}
        data-testid="button-top"
      >
        <FontAwesomeIcon
          icon={faChevronUp as IconProp}
          style={{ color: "var(--token-colors-white)" }}
          className="icon fa-solid fa-chevron-left"
        />
      </button>
    </div>
  );
};

export default ButtonGoToTop;
